import moment from 'moment';

export const formatDate = (date, format = 'YYYY/MM/DD') =>
  date ? moment(date).format(format) : date;

export const formatDateTime = (date, format = 'YYYY/MM/DD - HH:mm:ss') =>
  date ? moment(date).format(format) : date;

export const formatDateTimeForAPI = date =>
  date
    ? moment(date)
        .utc()
        .format()
    : date;
